import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {ButtonToolbar, Button, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import delay from '../../core/redux/delay'
import LoaderButton from '../../core/components/LoaderButton'
import {sendOpenTicketCmd, queryTicketStream, sendSimplifiedRequestQualified} from '../actions'
import i18n from '../i18n'
import style from './OpenTicketButtonToolbar.less'

class OpenTicketButtonToolbar extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object,
        step: PropTypes.number.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _sendCmd() {
        const {dispatch, cmd} = this.props
        const {requestUid} = cmd

        return dispatch(sendOpenTicketCmd()).then((action) => {
            const ticketId = action.events.find((e) => e.eventType == 'TicketOpened').aggregateUid
            dispatch(push('/tickets/' + ticketId))

            return sendSimplifiedRequestQualified(requestUid, ticketId)
                .then(() => {}, () => {})
                .then (() => {
                    return dispatch(delay(queryTicketStream()))
                })
        })
    }

    _open() {
        this.setState({opened: true})
    }

    _close() {
        this.setState({opened: false})
    }

    render() {
        const {dispatch, form, cmd, stream, step, onSubmit, ...others} = this.props
        const {opened} = this.state

        return (
            <div>
                <ButtonToolbar>
                    {step == 0.1 && (
                        <Button
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && (onSubmit(0.2) || true) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.next}
                        </Button>
                    )}
                    {step == 0.2 && (
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && (cmd.locationRef.patrimonyUid && stream.length > 0 && (this._open() || true) || this._sendCmd()) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.openTicket}
                        </LoaderButton>
                    )}
                </ButtonToolbar>
                <Modal
                    className='modal-danger'
                    show={opened}
                    onHide={() => this._close()}>
                    <Modal.Header>
                        <Modal.Title>{i18n.newTicket}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={style.text}>
                            {i18n.newTicketText.map((text, index) => (
                                <p key={index}>{text}</p>
                            ))}
                        </div>
                        <ButtonToolbar>
                            <LoaderButton
                                bsStyle='danger'
                                bsSize='large'
                                onClick={() => this._sendCmd()}>
                                {i18n.openTicket}
                            </LoaderButton>
                            <Button
                                bsSize='large'
                                onClick={() => this._close()}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

OpenTicketButtonToolbar = connect((state) => ({
    stream: state.ticket.minorStream
}))(OpenTicketButtonToolbar)

export default OpenTicketButtonToolbar


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketButtonToolbar.js